module.exports = __webpack_public_path__ + "static/stripboard_screen@2x-bcb52eec9edd630cc660ac027b78ff11.png";